import { useState } from "react";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { ScrollProps } from "../../components/AdvancedSearch";
import { Container, Content, Hero, PolicyCard } from "./styles";

export default function CookiesPolicy() {
  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const currentScrollTop = event.currentTarget.scrollTop;
    setScrollTop((prevState) => ({ y: currentScrollTop, lastY: prevState.y }));
  };

  return (
    <Container onScroll={handleScroll}>
      <Header
        show={show}
        setShow={setShow}
        scroll={scrollTop}
        search={search}
        setSearch={setSearch}
      />

      <Content>
        <Hero>
          <h1>Política de Cookies - Nogueira Corretores</h1>
        </Hero>

        <PolicyCard>
          <p>
            Como é prática comum em quase todos os sites profissionais, este
            site usa cookies, que são pequenos arquivos baixados no seu
            computador, para melhorar sua experiência. Esta seção descreve quais
            informações eles coletam, como as usamos e por que às vezes
            precisamos armazenar esses cookies. Também compartilharemos como
            você pode impedir que esses cookies sejam armazenados, no entanto,
            isso pode fazer o downgrade ou quebrar certos elementos da
            funcionalidade do site.
          </p>
          <p>
            Utilizamos cookies por vários motivos, detalhados abaixo. Na maioria
            dos casos, não existem opções padrão do setor para desativar os
            cookies sem desativar completamente a funcionalidade e os recursos
            que eles adicionam a este site. É recomendável que você deixe todos
            os cookies se não tiver certeza se precisa ou não deles, caso sejam
            usados para fornecer um serviço que você usa.
          </p>

          <h3>Desativar cookies</h3>
          <p>
            Você pode impedir a configuração de cookies ajustando as
            configurações do seu navegador (consulte a Ajuda do navegador para
            saber como fazer isso). Esteja ciente de que a desativação de
            cookies afetará a funcionalidade deste e de muitos outros sites que
            você visita.
          </p>
          <p>
            A desativação de cookies geralmente resultará na desativação de
            determinadas funcionalidades e recursos deste site. Portanto, é
            recomendável que você não desative os cookies.
          </p>

          <h3>Cookies que definimos</h3>
          <ul>
            <li>
              <strong>Cookies relacionados à conta:</strong> se você criar uma
              conta conosco, usaremos cookies para o gerenciamento do processo
              de inscrição e administração geral. Esses cookies geralmente serão
              excluídos quando você sair do sistema, porém, em alguns casos,
              eles poderão permanecer posteriormente para lembrar as
              preferências do seu site ao sair.
            </li>
            <li>
              <strong>Cookies relacionados às informações de contato:</strong>{" "}
              utilizamos cookies quando você preenche a informação de contato
              (Nome e E-mail), para, quando necessário, sugerir o preenchimento
              automático.
            </li>
            <li>
              <strong>Cookies relacionados a boletins por e-mail:</strong> este
              site oferece serviços de assinatura de boletim informativo ou
              e-mail e os cookies podem ser usados para lembrar se você já está
              registrado e se deve mostrar determinadas notificações válidas
              apenas para usuários inscritos ou não inscritos.
            </li>
            <li>
              <strong>Cookies relacionados a pesquisas:</strong> periodicamente,
              podemos oferecer pesquisas e questionários para fornecer
              informações interessantes, ferramentas úteis ou para entender
              nossa base de usuários com mais precisão. Essas pesquisas podem
              usar cookies para lembrar quem já participou numa pesquisa ou para
              fornecer resultados precisos após a alteração das páginas.
            </li>
            <li>
              <strong>Cookies relacionados a formulários:</strong> quando você
              envia dados por meio de um formulário como os encontrados nas
              páginas de contato ou nos formulários de comentários, os cookies
              podem ser configurados para lembrar os detalhes do usuário para
              correspondência futura.
            </li>
            <li>
              <strong>Cookies de preferências do site:</strong> para
              proporcionar uma ótima experiência neste site, fornecemos a
              funcionalidade para definir suas preferências de como esse site é
              executado quando você o usa. Para lembrar suas preferências,
              precisamos definir cookies para que essas informações possam ser
              trazidas sempre que você interagir com uma página for afetada por
              suas preferências.
            </li>
          </ul>

          <h3>Compromisso do usuário</h3>
          <p>
            O usuário se compromete a fazer uso adequado dos conteúdos e da
            informação que a Nogueira Corretores oferece no site e com caráter
            enunciativo, mas não limitativo:
          </p>
          <ul>
            <li>
              Não se envolver em atividades que sejam ilegais ou contrárias à
              boa fé ou à ordem pública;
            </li>
            <li>
              Não difundir propaganda ou conteúdo de natureza racista,
              xenofóbica, jogos de azar ou qualquer tipo de pornografia ilegal,
              de apologia ao terrorismo ou contra os direitos humanos;
            </li>
            <li>
              Não causar danos aos sistemas físicos (hardwares) e lógicos
              (softwares) da Nogueira Corretores, de seus fornecedores ou
              terceiros, para introduzir ou disseminar vírus informáticos ou
              quaisquer outros sistemas de hardware ou software que sejam
              capazes de causar danos anteriormente mencionados.
            </li>
          </ul>

          <h3>Mais informações</h3>
          <p>
            Esperemos que esteja esclarecido e, como mencionado anteriormente,
            se houver algo que você não tem certeza se precisa ou não,
            geralmente é mais seguro deixar os cookies ativados, caso interaja
            com um dos recursos que você usa em nosso site.
          </p>
          <span>
            <p>Esta política é efetiva a partir de agosto/2024.</p>
            <p style={{ marginTop: "1rem", fontWeight: 600, color: "#0E2244" }}>
              NOGUEIRA CORRETORES
            </p>
          </span>
        </PolicyCard>
      </Content>

      <Footer />
    </Container>
  );
}
